import {GetHealthProviderLocationPreviewParams} from 'domain/usecases/private/booking-flow/health/get-health-provider-location-preview';
import {makeGetHealthProviderLocationPreview} from 'main/factories/usecases/private/booking-flow/remote-health-booking/get-health-provider-location-preview-factory';

export async function getHealthProviderLocationPreview(
	params: GetHealthProviderLocationPreviewParams,
) {
	try {
		const response = await makeGetHealthProviderLocationPreview().get(params);

		return response;
	} catch {
		return {Content: true};
	}
}
